import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeViewComponent } from './home.view.component';
import { OrdersListComponent } from './modules/orders/orders-list/orders.list.component';
import { DeliveryNotesListComponent } from './modules/orders/delivery.notes.list.component';
import { ProjectStatusComponent } from './modules/orders/project-status/project.status.component';
import { ScannerComponent } from './modules/scanner/scanner.component';
import { EtaDocumentsComponent } from './modules/orders/eta/eta.documents.component';
import { OrderOverviewComponent } from './modules/orders/orders-overview/order.overview.component';
import { PlannedDeliveriesComponent } from './modules/orders/deliveries/planned.deliveries.component';
import { IncidentsListComponent } from './modules/incidents/incidents-list/incidents.list.component';
import { IncidentDetailsComponent } from './modules/incidents/incident-details/incident.details.component';
import { PmDocumentsComponent } from './modules/orders/position/pm/documents/pm.documents.component';
import { PmConstructionsComponent } from './modules/change/pm-constructions/pm-constructions.component';
import { PmSnrsComponent } from './modules/change/pm-snrs/pm-snrs.component';
import { PmSnrDocumentsComponent } from './modules/change/pm-documents/pm-snr-documents.component';
import { PmImportPrismaObjectsComponent } from './modules/change/pm-import-prisma-objects/pm-import-prisma-objects.component';
import { ContactsListComponent } from './modules/contacts/contacts-list/contacts.list.component';
import { ContactsDetailsComponent } from './modules/contacts/contacts-details/contacts.details.component';
import { PmProjectStatusComponent } from './modules/orders/project-status/pm/pm-project-status.component';
import { PmMultiProjectStatusComponent } from './modules/orders/project-status/pm/pm-multi-project-status.component';
import { BlanksOverviewComponent } from './modules/orders/position/bm/blanks-overview/blanks-overview.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'redirect',
  },
  {
    path: 'redirect',
    component: HomeViewComponent,
  },
  {
    path: 'orders',
    component: OrdersListComponent,
  },
  {
    path: 'orders/:id/overview',
    component: OrderOverviewComponent,
  },
  {
    path: 'orders/:id/:posId/deliverynotes',
    component: DeliveryNotesListComponent,
  },
  {
    path: 'orders/:id/:posId/projectstatus',
    component: ProjectStatusComponent,
  },
  {
    path: 'orders/:id/:posId/pm-project-status',
    component: PmProjectStatusComponent,
  },
  {
    path: 'orders/:id/pm-project-status',
    component: PmMultiProjectStatusComponent,
  },
  {
    path: 'orders/:id/:posId/etadocuments',
    component: EtaDocumentsComponent,
  },
  {
    path: 'orders/:id/:posId/pmdocuments',
    component: PmDocumentsComponent,
  },
  {
    path: 'orders/:id/:posId/planneddeliveries',
    component: PlannedDeliveriesComponent,
  },
  {
    path: 'orders/:id/:posId/blanks',
    component: BlanksOverviewComponent,
  },
  {
    path: 'orders/:id/:posId/incidents',
    component: IncidentsListComponent,
  },
  {
    path: 'orders/:id/:posId/incidents/:incidentId',
    component: IncidentDetailsComponent,
  },
  {
    path: 'incidents',
    component: IncidentsListComponent,
  },
  {
    path: 'scan',
    component: ScannerComponent,
  },
  {
    path: 'pm-constructions',
    component: PmConstructionsComponent,
  },
  {
    path: 'pm-constructions/:constructionId',
    component: PmSnrsComponent,
  },
  {
    path: 'pm-constructions/:constructionId/pm-indices/:indexId/snrs/:snrId/documents',
    component: PmSnrDocumentsComponent,
  },
  {
    path: 'pm-constructions/:constructionId/pm-indices/:indexId/prisma/import/:snrId',
    component: PmImportPrismaObjectsComponent,
  },
  {
    path: 'pm-constructions/:constructionId/pm-indices/:indexId/prisma/import',
    component: PmImportPrismaObjectsComponent,
  },
  {
    path: 'suppliers',
    component: ContactsListComponent,
  },
  {
    path: 'suppliers/:supplierId',
    component: ContactsDetailsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
